<template>
<div class="record-item-wrap">
    <div class="item-info-wrap flex rcb">
        <div class="item-title-wrap">
            <span class="title">{{item.withdrawal_type}}</span>
            <span class="amount">¥ {{item.amount}}</span>
        </div>
        <div class="item-detail-wrap">
            <div class="item-time">{{item.create_time}}</div>
        </div>
    </div>

    <div class="item-info-wrap flex rcb item-account-info">
        <div class="item-title-wrap">
            <div class="title" @click="onPressShowAccountInfo">{{item.account_info}}</div>
        </div>
    </div>

    <div class="item-info-wrap flex rcb item-account-info">
        <div class="success-time-wrap">{{item.other_info}}</div>
        <div class="item-status" :class="{'red': item.is_pass < 1}">{{item.is_pass_text}}</div>
    </div>
</div>
</template>

<script>
export default {
    name: "WithdrawRecordItem",
    props: ['item'],
    data() {
        return {

        };
    },
    methods: {
        onPressShowAccountInfo() {
            console.log('this.item---->', this.item);
        }
    },
};
</script>

<style lang="less" scoped>
.record-item-wrap {
    background: #fff;
    padding: 1rem 1.5rem;
    border-radius: .5rem;

    .item-info-wrap {
        line-height: 2;

        .title {}

        .amount {
            color: #f00;
            margin-left: 1rem;
            font-weight: 600;
        }

        .item-time {
            font-size: 1.3rem;
            color: #999;
        }

        .success-time-wrap {
            color: #666;
        }

        .item-status {
            color: #7181EB;

            &.red {
                color: #f00;
            }
        }
    }

    .item-account-info {}

    .item-account-info {}
}
</style>
